import React, {useState} from 'react'
import FormInput from './form_input'
import './style.css'

export default function FormPass(props) {

    const [show, setShow] = useState(false)

    const handling = _ => {
            setShow(!show)
    }

    console.log(handling)

    return (
        <div className="input_pass">
            <FormInput onClick={handling} cLable={props.cLablePass} lable={props.lablePass} value={props.value} onChange={props.onChange} type={show? "text" : "password"} place={props.placePass} src={show ? "asset/home/icons/eye-off.svg" : "asset/home/icons/eye.svg"} alt="eye" />
        </div>
    )
}
